import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const PaymentFirstName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="firstName"
      label="First Name"
      rules={[
        {
          required: true,
          message: "Please input first name",
        },
        // {
        //   whitespace: true,
        //   message: "Please input first name",
        // },
        {
          pattern: /^[A-Za-z]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input
        showCount
        maxLength={32}
        prefix={<UserOutlined className="form-item-icon" />}
        placeholder="First Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default PaymentFirstName;
